export default "__VITE_ASSET___FLE4xZ$__"